"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SprintSelect = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var use_get_my_sprints_1 = require("../hooks/use-get-my-sprints");
var select_1 = require("@hiyllo/ux/select");
var sprint_1 = require("@hiyllo/omni-common/src/types/tasks/sprint");
exports.SprintSelect = react_1["default"].memo(function SprintSelect(props) {
    var _a, _b, _c;
    var sprintsQuery = (0, use_get_my_sprints_1.useGetMySprints)();
    return ((0, jsx_runtime_1.jsx)(select_1.Select, { fullWidth: true, options: __spreadArray([
            {
                value: null,
                label: "<No Sprint>"
            }
        ], ((_b = (_a = sprintsQuery.data) === null || _a === void 0 ? void 0 : _a.sprints.map(function (p) { return ({
            label: p.teamName === null
                ? p.name
                : "".concat(p.name, " (").concat(p.status === sprint_1.SprintStatusEnum.active
                    ? "Current sprint for"
                    : "Upcoming sprint for", " ").concat(p.teamName, ")"),
            value: p.uuid
        }); })) !== null && _b !== void 0 ? _b : []), true), value: (_c = props.value) !== null && _c !== void 0 ? _c : null, onChangeValue: function (option) { return props.onChangeValue(option); } }));
});
